import type { ToolFaq } from "./soil-temperature"

export const herbicideTimingFaqs: ToolFaq[] = [
  {
    question: "When should I apply pre-emergent herbicide for crabgrass?",
    answer:
      "Pre-emergent herbicides should be applied before soil temperatures reach 55°F for 3 consecutive days. This is typically in late winter to early spring, depending on your region. In northern areas, this might be March-April, while in southern areas it could be February-March.",
  },
  {
    question: "What's the difference between pre-emergent and post-emergent herbicides?",
    answer:
      "Pre-emergent herbicides prevent weed seeds from germinating and should be applied before weeds appear. Post-emergent herbicides kill existing weeds and should be applied when weeds are actively growing. Some products can be used for both purposes depending on timing and application method.",
  },
  {
    question: "Can I apply herbicides in summer heat?",
    answer:
      "Summer application requires caution. Avoid applying during peak heat (above 85°F) as this can stress your grass and reduce herbicide effectiveness. Apply early morning or evening, ensure adequate soil moisture, and use products specifically labeled for summer application.",
  },
  {
    question: "Are herbicides safe for my grass type?",
    answer:
      "Different grass types have varying tolerance to herbicides. Cool-season grasses like Kentucky Bluegrass and Tall Fescue are generally more tolerant, while warm-season grasses may have different requirements. Always check the product label for grass type compatibility before applying.",
  },
  {
    question: "When is the best time to treat dandelions and broadleaf weeds?",
    answer:
      "Broadleaf weeds like dandelions are best controlled in fall (September-October) or early spring (March-April) when they're actively growing but not flowering. Fall application is often most effective because the herbicide is transported to the roots as the plant prepares for winter.",
  },
]
